export default "__VITE_ASSET__BpLY$2I6__"